import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { Modal } from 'react-responsive-modal';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
  addDomainUser,
  getDomainUserById,
  updateDomainUser,
  UploadMedia,
} from '../../../redux/MainAction';

const DomainAddModal = ({ open, onClose, editID }) => {
  const dispatch = useDispatch();

  const single = useSelector((state) => state.Webtracker.domainUserById);
  const ImageData = useSelector((state) => state.Webtracker.ImageData);

  const initialData = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    Cpassword: '',
    mobile: '',
    workspaceName: '',
  };

  const [addData, setAddData] = useState(initialData);

  const [imgURL, setImgURL] = useState('');
  const [imgID, setImgID] = useState(null);
  const [mediaName, setMediaName] = useState('');

  useEffect(() => {
    if (ImageData !== null) {
      if (mediaName === 'Image') {
        setImgID(ImageData?.id);
      }
    }
  }, [ImageData, mediaName]);

  useEffect(() => {
    getList();
  }, [editID]);

  const getList = () => {
    if (editID) {
      var pay = {
        id: editID,
      };
      dispatch(getDomainUserById(pay));
    }
  };

  const onImageChange = (e) => {
    setMediaName(e.target.name);
    var file = e.target.files[0];
    var url = URL.createObjectURL(e.target.files[0]);
    setImgURL(url);

    const formData = new FormData();

    formData.append('files', file);

    dispatch(UploadMedia(formData));
  };

  const onChangeData = (e) => {
    const { name, value } = e.target;
    setAddData({ ...addData, [name]: value });
  };

  useEffect(() => {
    if (editID) {
      setAddData({
        firstName: single?.firstName || '',
        lastName: single?.lastName || '',
        email: single?.email || '',
        mobile: single?.userDetail?.mobile || '',
      });

      if (single?.media) {
        setImgURL(single.media?.url);
        setImgID(single?.media?.id);
      }
    } else {
      setAddData(initialData);
      setImgURL('');
      setImgID(null);
    }
  }, [single, editID]);

  const onSaveHandle = (e) => {
    e.preventDefault();

    if (!editID) {
      if (addData?.workspaceName === '') {
        toast.error('Please Add workspace name !', {
          position: 'top-right',
        });
        return false;
      }
      if (addData?.firstName === '') {
        toast.error('Please Add first name !', {
          position: 'top-right',
        });
        return false;
      }
      if (addData?.lastName === '') {
        toast.error('Please Add last name !', {
          position: 'top-right',
        });
        return false;
      }
      if (addData?.email === '') {
        toast.error('Please Add email !', {
          position: 'top-right',
        });
        return false;
      }
      if (addData?.mobile === '') {
        toast.error('Please Add contact no. !', {
          position: 'top-right',
        });
        return false;
      }
      if (addData?.password !== addData?.Cpassword) {
        toast.error('Password & Confirm Password not Matched !', {
          position: 'top-right',
        });
        return false;
      }

      const payload = {
        firstName: addData?.firstName,
        lastName: addData?.lastName,
        email: addData?.email,
        password: addData?.password,
        mobile: addData?.mobile,
        workspaceName: addData?.workspaceName,
      };

      if (imgID !== null) {
        payload.mediaId = imgID;
      }

      dispatch(addDomainUser(payload));
      onClose();
      setAddData({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        Cpassword: '',
        mobile: '',
        workspaceName: '',
      });
    } else {
      const payload = {
        id: editID,
        firstName: addData?.firstName,
        lastName: addData?.lastName,
      };
      if (imgID !== null) {
        payload.mediaId = imgID;
      }
      dispatch(updateDomainUser(payload));
      onClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      showCloseIcon={false}
      classNames={{ modal: 'custom-modal' }}
    >
      <div className="d-flex justify-content-between align-items-center">
        <h5>{!editID ? 'New' : 'Update'} Domain</h5>
        <i
          onClick={onClose}
          className="fa fa-times font-20"
          style={{ cursor: 'pointer' }}
        ></i>
      </div>
      <div className="tab-content">
        <div className="row col-12">
          {!editID ? (
            <div className="form-group col-12">
              <label for="username1" className="font-14 text-muted ">
                Workspace Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter First Name"
                className="form-control"
                name="workspaceName"
                value={addData?.workspaceName}
                onChange={onChangeData}
                id="workspaceName"
              />
            </div>
          ) : null}

          <div className="form-group col-6">
            <label for="domainFirstName" className="font-14 text-muted ">
              First Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter First Name"
              className="form-control"
              name="firstName"
              value={addData?.firstName}
              onChange={onChangeData}
              id="domainFirstName"
            />
          </div>
          <div className="form-group col-6">
            <label for="domainLastName" className="font-14 text-muted ">
              Last Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter Last Name"
              className="form-control"
              name="lastName"
              value={addData?.lastName}
              onChange={onChangeData}
              id="domainLastName"
            />
          </div>
        </div>
        <div className="row col-12">
          <div className="form-group col-6">
            <label for="domainEmail" className="font-14 text-muted ">
              Email <span className="text-danger">*</span>
            </label>
            <input
              type="email"
              placeholder="Enter Email"
              className="form-control"
              name="email"
              disabled={editID}
              value={addData?.email}
              onChange={onChangeData}
              autocomplete="off"
              id="domainEmail"
            />
          </div>
          <div className="form-group col-6">
            <label for="domainMobile" className="font-14 text-muted ">
              Contact No <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              placeholder="Enter Contact No"
              className="form-control"
              name="mobile"
              disabled={editID}
              value={addData?.mobile}
              onChange={onChangeData}
              id="domainMobile"
            />
          </div>
        </div>
        {!editID ? (
          <div className="row col-12">
            <div className="form-group col-6">
              <label for="domainPassword" className="font-14 text-muted ">
                Password <span className="text-danger">*</span>
              </label>
              <input
                type="password"
                placeholder="Enter Password"
                className="form-control"
                name="password"
                value={addData?.password}
                autocomplete="off"
                onChange={onChangeData}
                id="domainPassword"
              />
            </div>
            <div className="form-group col-6">
              <label for="domainCpassword" className="font-14 text-muted ">
                Confirm Password <span className="text-danger">*</span>
              </label>
              <input
                type="password"
                placeholder="Enter Confirm Password"
                className="form-control"
                name="Cpassword"
                value={addData?.Cpassword}
                autocomplete="off"
                onChange={onChangeData}
                id="domainCpassword"
              />
            </div>
          </div>
        ) : (
          ''
        )}

        <div className="row col-12">
          <div className="form-group col-12">
            <label for="domainFile" className="font-14 text-muted ">
              Logo
            </label>
            <input
              type="file"
              className="form-control"
              name="Image"
              accept="image/*"
              onChange={onImageChange}
              id="domainFile"
            />
          </div>
          {imgURL ? (
            <div style={{ width: '100%', textAlign: 'center' }}>
              <img src={imgURL} height="110px" width="auto" />
            </div>
          ) : null}
        </div>
      </div>
      <div className="modal-footer">
        <Button size="sm" className="btn btn-light" onClick={onClose}>
          Cancel
        </Button>
        <Button size="sm" className="btn btn-primary" onClick={onSaveHandle}>
          {!editID ? 'Create' : 'Update'} Domain
        </Button>
      </div>
    </Modal>
  );
};

export default DomainAddModal;
